module.exports = __webpack_public_path__ + "static/media/taffiethule13.e4f7c171.jpg";